// Datos de ejemplo para poblar la tabla
export const dataRegistros = [
    {
      nombre: "Titular del perfil de facebook \"POLIMEMES DEL SUR\".",
      sexo: "N/A",
      ambito: "Estatal",
      entidad: "Tlaxcala",
      municipio: "XICOHTZINCO, TLAXCALA",
      relacion: "N/A",
      incidencia: "N/A",
      expediente: "TET-PES-071/2024",
      organo: "Tribunal Electoral de Tlaxcala",
      fecha: "21 de Julio de 2025",
      conducta: "Violencia política contra las mujeres en razón de genero",
      sancion: "Inscripción en el Registro Nacional de Personas Sancionadas en Materia de Violencia Política contra las mujeres en razón de genero del INE y el Registro Estatal de Personas Sancionadas en materia de Violencia Política Contra las Mujeres en Razón de Género del ITE", 
      permanencia: "2 años",
      analizo: "N/A",
      cumple: "N/A",
      calidad: "Titular y/o administrador de perfil de Facebook",
      documento: "https://sistemas-tet.org.mx/estrados/archivos/20250730210432_ACUERDO-PES-071-2024.pdf",
    },
    {
        nombre: "Titular del perfil de facebook \"SANTOCHO LIBRE EXPRESIÓN\".",
        sexo: "Hombre",
        ambito: "Estatal",
        entidad: "Tlaxcala",
        municipio: "XICOHTZINCO, TLAXCALA",
        relacion: "N/A",
        incidencia: "N/A",
        expediente: "TET-PES-071/2024",
        organo: "Tribunal Electoral de Tlaxcala",
        fecha: "21 de Julio de 2025",
        conducta: "Violencia política contra las mujeres en razón de genero",
        sancion: "Inscripción en el Registro Nacional de Personas Sancionadas en Materia de Violencia Política contra las mujeres en razón de genero del INE y el Registro Estatal de Personas Sancionadas en materia de Violencia Política Contra las Mujeres en Razón de Género del ITE", 
        permanencia: "2 años",
        analizo: "N/A",
        cumple: "N/A",
        calidad: "Titular y/o administrador de perfil de Facebook",
        documento: "https://sistemas-tet.org.mx/estrados/archivos/20250730210432_ACUERDO-PES-071-2024.pdf",
      },
  ];
  
  // Datos para las infografías
  export const dataInfografias = [
    /* {
      id: 1,
      link: "https://itetlax.org.mx/assets/img/reps/info1.png",
      alt: "Infografía 1",
    },
    {
      id: 2,
      link: "https://itetlax.org.mx/assets/img/reps/info2.png",
      alt: "Infografía 2",
    }, */
  ];
  